import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "banafo-design-system";
import BulletSteps from "src/features/wizard/BulletSteps";
const WizardModalFooter = ({ activeStep }) => {
    return (_jsx(Modal.Footer, { className: "justify-content-center", children: _jsx(BulletSteps, { totalSteps: 3, active: activeStep }) }));
};
export default WizardModalFooter;
